module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleD5.fe4896a7.png";